module.exports = __webpack_public_path__ + "static/home-hero-image-1.603c87f2.jpg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/images/home-hero-image-1.jpg
// module id = 530
// module chunks = 1